import { useState, useEffect } from 'react';
import { CloseOutlined, InfoOutlined, CampaignOutlined, ShoppingCartOutlined, Delete, DeleteOutline, Edit } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { Button, Zoom, Tooltip, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography, IconButton } from "@mui/material";
import { socket } from "../../../../../../../components/Socket/cliente";
import { api, fetchCSRFToken } from "../../../../../../../services/api";
import SelectUbicacionModal from "../../../../../../../components/modales/ubicaciones/SelectUbicacionModal";
import { useAuth } from "../../../../../../../components/context/AuthContext";
const EventoTarifas = ({ data, cantidad, toggleDrawer, setCantidad, tarifasTicketsFiltrados, tarifasVouchersFiltrados, setTarifasSeleccionadas, asientosSeleccionados,
  setAsientosSeleccionados, }) => {

  const [modalSeleccionOpen, setModalSeleccionOpen] = useState(false);
  const [tarifaSeleccionada, setTarifaSeleccionada] = useState(null);

  const [seleccionActual, setSeleccionActual] = useState({ asientos: [], mesas: {} });
  const [asientosOcupados, setAsientosOcupados] = useState([]);

  const convertirColorRGBA = (colorObj) => {
    if (!colorObj) {
      return '#5656ff';
    }

    try {
      let colorData;
      // parsear como json
      if (typeof colorObj === 'string') {
        colorData = JSON.parse(colorObj);
      } else if (typeof colorObj === 'object') {
        colorData = colorObj;
      } else {
        return '#5656ff';
      }

      if (!colorData || typeof colorData !== 'object') {
        return '#5656ff';
      }

      const { r, g, b, a = 1 } = colorData;

      // numeros validos
      const red = Math.max(0, Math.min(255, Number(r) || 0));
      const green = Math.max(0, Math.min(255, Number(g) || 0));
      const blue = Math.max(0, Math.min(255, Number(b) || 0));
      const alpha = Math.max(0, Math.min(1, Number(a) || 1));

      return `rgba(${red}, ${green}, ${blue}, ${alpha})`;

    } catch (error) {
      console.warn('Error parseando color de tarifa:', error);
      return '#5656ff';
    }
  };

  useEffect(() => {
    if (!data?.id) return;

    const eventoId = data.id;

    // escuchamos cambios del socket
    socket.on(`evento-${eventoId}-asientos-update`, (update) => {
      // actualizar la lista
      setAsientosOcupados(prev => {
        if (update.ocupado) {
          // si no esta en la lista, ocupamos
          return prev.includes(update.asientoId) ? prev : [...prev, update.asientoId];
        } else {
          // si al final no se ocupa, lo sacamos
          return prev.filter(id => id !== update.asientoId);
        }
      });
    });

    // limpiamos
    return () => {
      socket.off(`evento-${eventoId}-asientos-update`);
    };
  }, [data?.id]);

  const abrirModalSeleccion = (tarifa) => {
    setTarifaSeleccionada(tarifa);
    setModalSeleccionOpen(true);
    setSeleccionActual(asientosSeleccionados[tarifa.id] || { asientos: [], mesas: {} });
  };

  const confirmarAsientos = ({ cantidad: nuevaCantidad, asientos, mesas }) => {
    setCantidad(prev => ({
      ...prev,
      [tarifaSeleccionada.id]: nuevaCantidad
    }));

    setAsientosSeleccionados(prev => ({
      ...prev,
      [tarifaSeleccionada.id]: {
        asientos: asientos || [],
        mesas: mesas || {}
      }
    }));

    setModalSeleccionOpen(false);
  };

  const eliminarSeleccion = (tarifaId) => {
    setCantidad(prev => ({
      ...prev,
      [tarifaId]: 0
    }));
    setAsientosSeleccionados(prev => ({
      ...prev,
      [tarifaId]: { asientos: [], mesas: {} }
    }));
  };

  const { isAuthenticated, loginWithRedirect } = useAuth();

  const incremento = (idtarifa) => {
    setCantidad((prevCantidades) => {
      const nuevaCantidad = (prevCantidades[idtarifa] || 0) + 1;

      const tarifa = data?.tarifas?.find((tarifa) => tarifa.id === idtarifa);
      let limite = tarifa
        ? Math.min(
          tarifa.restantes,
          tarifa?.ubicacion?.limitepersona || tarifa.restantes
        )
        : 0;

      if (nuevaCantidad > parseInt(limite)) {
        return prevCantidades;
      }

      return {
        ...prevCantidades,
        [idtarifa]: nuevaCantidad,
      };
    });
  };

  const decremento = (idtarifa) => {
    setCantidad((prevCantidades) => ({
      ...prevCantidades,
      [idtarifa]: Math.max(0, (prevCantidades[idtarifa] || 0) - 1),
    }));
  };

  /* CALCULOS TARIFAS */
  const calculoSubtotalTarifa = (tarifa) => {
    const cantidadTarifa = cantidad[tarifa.id] || 0;
    return cantidadTarifa * tarifa.precio;
  };

  const subtotal =
    data?.tarifas?.reduce((acc, tarifa) => {
      return acc + calculoSubtotalTarifa(tarifa);
    }, 0) || 0;

  const comision =
    data?.tarifas?.reduce((acc, tarifa) => {
      const cantidadTarifa = cantidad[tarifa.id] || 0;
      const precioConComision =
        tarifa?.precio *
        (!tarifa?.asumir_comision
          ? tarifa?.tipo_comision?.porcentaje / 100
          : 0);

      return acc + cantidadTarifa * precioConComision;
    }, 0) || 0;

  const calcularTotal = () => {
    const total = subtotal + comision;
    return total;
  };

  const totalFormateado = calcularTotal().toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  const handleStartPurchase = async () => {
    const seleccionadas = data.tarifas.filter(
      (tarifa) => (cantidad[tarifa.id] || 0) > 0
    );

    if (!isAuthenticated) {
      await loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
      return;
    }

    try {
      await fetchCSRFToken();
      /*  console.log("CSRF Token obtenido correctamente:", sessionStorage.getItem('csrf_token')); */
    } catch (error) {
      console.error("Error obteniendo token CSRF:", error);
    }

    setTarifasSeleccionadas(seleccionadas.map(tarifa => ({
      ...tarifa,
      asientosSeleccionados: asientosSeleccionados[tarifa.id] || { asientos: [], mesas: {} }
    })));
    toggleDrawer(true)();
  };

  return (
    <div className="w-100 pb-4" style={{ maxWidth: "400px", marginRight: "40px" }}>
      {(!tarifasTicketsFiltrados && !tarifasVouchersFiltrados) ||
        (tarifasTicketsFiltrados?.length === 0 &&
          tarifasVouchersFiltrados?.length === 0) ? (
        <>
          <div
            className="d-flex align-items-center flex-column "
            style={{ position: "sticky", top: "0", paddingTop: "28px" }}
          >
            <div
              className="contenedor-badge px-4 py-2"
              style={{
                background: "#dadaff",
                color: "#3d2eab",
                fontSize: "24px",
              }}
            >
              <CampaignOutlined
                sx={{
                  width: "45px",
                  height: "45px",
                  marginRight: "22px",
                }}
              />
              {/* <div className="d-flex flex-column">
                <small className="fw-bold" style={{ fontSize: "18px" }}>
                ¡Gracias por tu interés!
                </small>
                <small style={{ fontSize: "14px" }}>
                Actualmente no hay entradas disponibles para este evento.
                </small>
              </div> */}
              <div className="d-flex flex-column">
                <small className="fw-bold" style={{ fontSize: "18px", }}>
                  ¡Estate atento/a y no te quedes afuera!
                </small>
                <small style={{ fontSize: "16px" }}>
                  Próximamente, entradas a la venta.
                </small>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {(tarifasTicketsFiltrados?.length > 0 ||
            tarifasVouchersFiltrados?.length > 0) && (
              <div
                style={{ position: "sticky", top: "0", paddingTop: "28px" }}
              >
                {tarifasTicketsFiltrados?.length > 0 && (
                  <TableContainer
                    sx={{ borderRadius: "10px", border: "1px solid #ddd" }}
                  >
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: "#FFD400" }}>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontFamily: "Inter, sans-serif",
                              padding: "6px 16px",
                            }}
                          >
                            ENTRADAS
                          </TableCell>
                          <TableCell
                            sx={{ fontFamily: "Inter, sans-serif" }}
                          >
                            PRECIO
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily: "Inter, sans-serif",
                              textAlign: "center",
                            }}
                          >
                            CANT.
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tarifasTicketsFiltrados?.map((tarifa) => (
                          <TableRow key={tarifa.id} sx={{}}>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                border: "0",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", /* padding: "0 8px", */ width: "100%" }}>
                                <div
                                  style={{
                                    backgroundColor: convertirColorRGBA(tarifa.color),
                                    height: "12px",
                                    width: "12px",
                                    minWidth: "12px",
                                    maxWidth: "12px",
                                    borderRadius: "50%",
                                    flexShrink: 0,
                                    display: "inline-block"
                                  }}
                                />
                                <p style={{
                                  marginBottom: "0",
                                  flex: 1,
                                  wordWrap: "break-word",
                                  lineHeight: "1.2"
                                }}>
                                  {tarifa.concepto}
                                </p>
                              </div>
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                border: "0",
                              }}
                            >
                              ${tarifa.precio}
                            </TableCell>
                            <TableCell sx={{ fontFamily: "Inter, sans-serif", border: "0" }}>
                              <div className="d-flex flex-row gap-4">
                                {tarifa?.restantes > 0 ? (
                                  <>
                                    {/* TARIFAS TIPO 1*/}
                                    {(!tarifa.ubicacion || tarifa.ubicacion.tipo_ubicacion === 1) ? (
                                      <>
                                        <Button
                                          className=""
                                          disabled={cantidad[tarifa.id] === 0}
                                          onClick={() => decremento(tarifa.id)}
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: cantidad[tarifa.id] === 0 ? "#ddd" : "white",
                                            backgroundColor: cantidad[tarifa.id] === 0 ? "#ddd" : "#5656ff",
                                            padding: "0",
                                            fontSize: "15px !important",
                                            textAlign: "center",
                                          }}
                                          aria-label="restar"
                                        >
                                          -
                                        </Button>
                                        <Button
                                          className="fw-bold"
                                          disabled
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: "black",
                                            cursor: "default",
                                            padding: "0",
                                            "&.Mui-disabled": {
                                              color: "black",
                                              pointerEvents: "none",
                                            },
                                          }}
                                        >
                                          {cantidad[tarifa.id] || 0}
                                        </Button>
                                        <Button
                                          className=""
                                          onClick={() => incremento(tarifa.id)}
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: "white",
                                            backgroundColor: "#5656ff",
                                            padding: "0",
                                            fontSize: "15px !important",
                                            textAlign: "center",
                                          }}
                                          aria-label="sumar"
                                        >
                                          +
                                        </Button>
                                      </>
                                    ) : (
                                      /* TARIFA TIPO 2 Y 3 */
                                      <>
                                        {!(asientosSeleccionados[tarifa.id]?.asientos?.length > 0 || Object.keys(asientosSeleccionados[tarifa.id]?.mesas || {}).length > 0) ? (
                                          <Button
                                            variant="contained"
                                            onClick={() => abrirModalSeleccion(tarifa)}
                                            sx={{
                                              height: "32px",
                                              bgcolor: "#5656ff",
                                              color: "white",
                                              fontSize: '12px',
                                              padding: '4px 12px',
                                              '&:hover': { bgcolor: '#4545CC' }
                                            }}
                                          >
                                            Seleccionar
                                          </Button>
                                        ) : (
                                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'center', width: "100%", gap: "20px" }}>
                                            <Typography
                                              onClick={() => abrirModalSeleccion(tarifa)}
                                              sx={{ color: "#5656ff", fontSize: "20px", fontWeight: 700, cursor: "pointer" }}>
                                              {`${(asientosSeleccionados[tarifa.id]?.asientos?.length || 0) +
                                                Object.values(asientosSeleccionados[tarifa.id]?.mesas || {}).reduce((a, b) => a + b, 0)}`}
                                            </Typography>
                                            <IconButton
                                              sx={{
                                                bgcolor: "transparent",
                                                color: "red",
                                                fontSize: '12px !important',
                                                padding: '0',
                                                border: 'none',
                                                display: "flex",
                                                '&:hover': { color: '#0b0062' }
                                              }}
                                              onClick={() => eliminarSeleccion(tarifa.id)}
                                              aria-label="delete"
                                              size="small"
                                            >
                                              <DeleteOutline style={{ color: "red" }} />
                                            </IconButton>
                                            {/* <Button
                                              variant="outlined"
                                              onClick={() => abrirModalSeleccion(tarifa)}
                                              sx={{
                                                bgcolor: "#ceceff",
                                                color: "#5656ff",
                                                fontSize: '12px !important',
                                                padding: '4px 10px',
                                                border: '1px solid #5656ff',
                                                display: "flex",
                                                '&:hover': { bgcolor: '#e0e7ff' }
                                              }}
                                            >
                                              Seleccionados ({`${(asientosSeleccionados[tarifa.id]?.asientos?.length || 0) +
                                                Object.values(asientosSeleccionados[tarifa.id]?.mesas || {}).reduce((a, b) => a + b, 0)
                                                }`})
                                            </Button> */}
                                            {/* <Button
                                              variant="text"
                                              color="error"
                                              onClick={() => eliminarSeleccion(tarifa.id)}
                                              sx={{
                                                fontSize: '12px',
                                                padding: '4px 8px',
                                              }}
                                            >
                                              Eliminar
                                            </Button> */}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <small className="cartel-agotados p-1 rounded">
                                    <CloseOutlined sx={{ width: "16px", height: "16px" }} /> Agotado
                                  </small>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                <div style={{ marginTop: "15px" }}>
                  {tarifasVouchersFiltrados.length > 0 && (
                    <TableContainer
                      sx={{
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Table size="small">
                        <TableHead sx={{ backgroundColor: "#FFD400" }}>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                padding: "6px 16px",
                              }}
                            >
                              VOUCHER
                            </TableCell>
                            <TableCell
                              sx={{ fontFamily: "Inter, sans-serif" }}
                            >
                              PRECIO
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                textAlign: "center",
                              }}
                            >
                              CANT.
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tarifasVouchersFiltrados.map((tarifa) => (
                            <TableRow key={tarifa.id} sx={{}}>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                {tarifa.concepto}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                ${tarifa.precio}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                <div className="d-flex flex-row gap-4">
                                  {tarifa?.restantes > 0 ? (
                                    <>
                                      <Button
                                        className=""
                                        disabled={cantidad[tarifa.id] === 0}
                                        onClick={() =>
                                          decremento(tarifa.id)
                                        }
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color:
                                            cantidad[tarifa.id] === 0
                                              ? "#ddd"
                                              : "white",
                                          backgroundColor:
                                            cantidad[tarifa.id] === 0
                                              ? "#ddd"
                                              : "#5656ff",
                                          padding: "0",
                                          fontSize: "15px !important",
                                          textAlign: "center",
                                        }}
                                        aria-label="restar"
                                      >
                                        -
                                      </Button>
                                      <Button
                                        className="fw-bold"
                                        disabled
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color: "black",
                                          cursor: "default",
                                          padding: "0",
                                          "&.Mui-disabled": {
                                            color: "black",
                                            pointerEvents: "none",
                                          },
                                        }}
                                      >
                                        {cantidad[tarifa.id] || 0}
                                      </Button>
                                      <Button
                                        className=""
                                        onClick={() =>
                                          incremento(tarifa.id)
                                        }
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color: "white",
                                          backgroundColor: "#5656ff",
                                          padding: "0",
                                          fontSize: "15px !important",
                                          textAlign: "center",
                                        }}
                                        aria-label="sumar"
                                      >
                                        +
                                      </Button>
                                    </>
                                  ) : (
                                    <small className="cartel-agotados p-1 rounded">
                                      <CloseOutlined
                                        sx={{
                                          width: "16px",
                                          height: "16px",
                                        }}
                                      />{" "}
                                      Agotado
                                    </small>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
                <div
                  className="d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: grey[200],
                    borderRadius: "5px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    className="d-flex justify-content-between flex-wrap py-2"
                    style={{
                      backgroundColor: "transparent",
                      padding: "6px 16px",
                    }}
                  >
                    <div className="d-flex flex-row align-items-center">
                      <p
                        className="fw-bold mb-0 fs-6"
                        style={{
                          color: !Object.values(cantidad).some(
                            (val) => val > 0
                          )
                            ? grey[800]
                            : "black",
                        }}
                      >
                        TOTAL
                      </p>
                      <Tooltip
                        arrow
                        TransitionComponent={Zoom}
                        placement="right"
                        title="El precio incluye impuestos"
                      >
                        <InfoOutlined
                          sx={{
                            width: "18px",
                            height: "18px",
                            marginLeft: "5px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <span className="text-end">
                      <p
                        className="fw-bold mb-0 fs-6"
                        style={{
                          color: !Object.values(cantidad).some(
                            (val) => val > 0
                          )
                            ? grey[800]
                            : "black",
                        }}
                      >
                        $ {totalFormateado}
                      </p>
                    </span>
                  </div>
                  <Button
                    className=""
                    onClick={handleStartPurchase}
                    sx={{
                      padding: "8px 10px",
                      fontFamily: "Inter, sans-serif",
                      backgroundColor: "#5656FF",
                      outline: "none",
                      color: "white",
                      borderRadius: "10px !important",
                      "&:disabled": {
                        backgroundColor: "#ddd",
                        color: grey[800],
                      },
                    }}
                    disabled={
                      !Object.values(cantidad).some((val) => val > 0)
                    }
                  >
                    Comenzar compra{" "}
                    <ShoppingCartOutlined
                      sx={{
                        color: !Object.values(cantidad).some(
                          (val) => val > 0
                        )
                          ? grey[800]
                          : "white",
                        width: "18px",
                        height: "18px",
                        marginLeft: "5px",
                      }}
                    />
                  </Button>
                </div>
              </div>
            )}
        </>
      )}
      <SelectUbicacionModal
        open={modalSeleccionOpen}
        onClose={() => setModalSeleccionOpen(false)}
        tarifa={tarifaSeleccionada}
        cantidadSeleccionada={cantidad[tarifaSeleccionada?.id] || 0}
        seleccionActual={seleccionActual}
        onConfirmar={confirmarAsientos}
      />
    </div>
  );
};

export default EventoTarifas;